(function () {
  var STORAGE_KEY = "mnare_wishlist";

  function getItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateUI();
  }

  function formatMoney(cents) {
    return "\u20AC\u00A0" + (cents / 100).toFixed(2).replace(".", ",");
  }

  function getToggleButton() {
    return document.querySelector("[data-wishlist-toggle]");
  }

  function isInWishlist(variantId) {
    return getItems().some(function (item) {
      return String(item.variantId) === String(variantId);
    });
  }

  function readToggleData(btn) {
    return {
      productId: btn.dataset.productId,
      variantId: btn.dataset.variantId,
      handle: btn.dataset.productHandle,
      title: btn.dataset.productTitle,
      variantTitle: btn.dataset.variantTitle,
      url: btn.dataset.productUrl,
      image: btn.dataset.productImage,
      price: parseInt(btn.dataset.variantPrice, 10) || 0,
    };
  }

  function wishlistStrings() {
    var s = (window.theme && window.theme.strings) || {};
    return {
      save: s.saveToWishlist || s.products && s.products.product && s.products.product.save_to_wishlist || "Save to wishlist",
      saved: s.savedToWishlist || s.products && s.products.product && s.products.product.saved_to_wishlist || "Saved to wishlist",
    };
  }

  function setToggleButtonState(btn, active) {
    if (!btn) return;
    btn.classList.toggle("is-in-wishlist", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
    var label = btn.querySelector("[data-wishlist-label]");
    if (label) {
      var strings = wishlistStrings();
      label.textContent = active ? strings.saved : strings.save;
    }
    var icon = btn.querySelector("[data-wishlist-icon]");
    if (icon) {
      icon.textContent = active ? "\u2665" : "\u2661";
    }
  }

  function updateToggleButton() {
    var btn = getToggleButton();
    if (!btn || !btn.dataset.variantId) return;
    setToggleButtonState(btn, isInWishlist(btn.dataset.variantId));
  }

  function updateCount() {
    var count = getItems().length;
    document.querySelectorAll(".js-wishlist-count").forEach(function (el) {
      el.textContent = count > 0 ? "(" + count + ")" : "0";
      el.classList.toggle("hidden", count === 0);
    });
  }

  function escapeHtml(text) {
    return String(text || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function isWishlistPagePath() {
    var path = window.location.pathname.replace(/\/$/, "");
    return path === "/pages/wishlist" || path.endsWith("/pages/wishlist");
  }

  function getPageRoot() {
    var root = document.querySelector("[data-wishlist-page]");
    if (root) return root;

    if (!isWishlistPagePath()) return null;

    var pageContent =
      document.querySelector("#main-content .page .page__content") ||
      document.querySelector("#main-content .page__content");
    if (!pageContent) return null;

    root = document.createElement("div");
    root.className = "wishlist-page__content";
    root.setAttribute("data-wishlist-page", "");
    root.setAttribute(
      "data-empty-message",
      "Your wishlist is empty. Save items using the button on the product page."
    );

    var rte = pageContent.querySelector(".rte");
    if (rte) rte.style.display = "none";

    pageContent.classList.add("wishlist-page");
    pageContent.appendChild(root);
    return root;
  }

  function renderPage() {
    var root = getPageRoot();
    if (!root) return;

    var items = getItems();
    var emptyMsg = root.dataset.emptyMessage || "Your wishlist is empty.";

    if (!items.length) {
      root.innerHTML = '<p class="wishlist-page__empty type-body-regular">' + emptyMsg + "</p>";
      return;
    }

    root.innerHTML =
      '<div class="wishlist-page__grid">' +
      items
        .map(function (item) {
          var variantLabel =
            item.variantTitle && item.variantTitle !== "Default Title"
              ? '<p class="wishlist-page__variant">' + item.variantTitle + "</p>"
              : "";
          return (
            '<article class="wishlist-page__item" data-variant-id="' +
            item.variantId +
            '">' +
            '<a href="' +
            item.url +
            '" class="wishlist-page__image">' +
            (item.image
              ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
              : "") +
            "</a>" +
            '<div class="wishlist-page__details">' +
            '<a href="' +
            escapeHtml(item.url) +
            '" class="wishlist-page__title">' +
            escapeHtml(item.title) +
            "</a>" +
            variantLabel +
            '<p class="wishlist-page__price">' +
            formatMoney(item.price) +
            "</p>" +
            '<button type="button" class="wishlist-page__remove" data-wishlist-remove="' +
            item.variantId +
            '">Remove</button>' +
            "</div>" +
            "</article>"
          );
        })
        .join("") +
      "</div>";
  }

  function toggleFromButton(btn) {
    var data = readToggleData(btn);
    if (!data.variantId) return;

    var items = getItems();
    var index = items.findIndex(function (item) {
      return String(item.variantId) === String(data.variantId);
    });

    if (index > -1) {
      items.splice(index, 1);
      setToggleButtonState(btn, false);
    } else {
      items.push(data);
      setToggleButtonState(btn, true);
    }

    saveItems(items);
  }

  function removeItem(variantId) {
    var items = getItems().filter(function (item) {
      return String(item.variantId) !== String(variantId);
    });
    saveItems(items);
    updateToggleButton();
  }

  function updateUI() {
    updateCount();
    updateToggleButton();
    renderPage();
  }

  var eventsBound = false;

  function bindEvents() {
    if (eventsBound) return;
    eventsBound = true;

    document.addEventListener("click", function (e) {
      var toggle = e.target.closest("[data-wishlist-toggle]");
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        toggleFromButton(toggle);
        return;
      }

      var removeBtn = e.target.closest("[data-wishlist-remove]");
      if (removeBtn) {
        e.preventDefault();
        removeItem(removeBtn.getAttribute("data-wishlist-remove"));
      }
    });
  }

  function init() {
    bindEvents();
    updateUI();

    if (isWishlistPagePath()) {
      setTimeout(updateUI, 50);
      setTimeout(updateUI, 300);
      setTimeout(updateUI, 1000);
    }
  }

  window.MnareWishlist = {
    getItems: getItems,
    updateUI: updateUI,
    updateToggleButton: updateToggleButton,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("pageshow", function () {
    if (isWishlistPagePath()) {
      updateUI();
    }
  });

  function loadMnareContactCss() {
    if (document.getElementById("mnare-contact-css")) return;
    var customLink = document.querySelector('link[href*="custom.css"]');
    if (!customLink) return;
    var link = document.createElement("link");
    link.id = "mnare-contact-css";
    link.rel = "stylesheet";
    link.href = customLink.href.replace(/custom\.css/, "mnare-contact.css");
    document.head.appendChild(link);
  }

  function shouldSkipContactRefresh() {
    return !!document.querySelector(
      ".contact__form .form-status__message--success, .contact__form .form-status__message--error"
    );
  }

  function refreshContactSection() {
    if (window.location.pathname.replace(/\/$/, "") !== "/pages/contact") return;
    if (shouldSkipContactRefresh()) return;

    loadMnareContactCss();

    var contact = document.querySelector(".contact.section");
    if (!contact) return;

    var marker = document.querySelector(".mnare-contact-marker[data-layout='v7']");
    var layoutOk = marker && contact.classList.contains("contact--centered");

    if (layoutOk) return;

    var wrapper = contact.closest(".shopify-section");
    if (!wrapper || !wrapper.id) return;

    var sectionId = wrapper.id.replace("shopify-section-", "");
    fetch(window.location.pathname + "?section_id=" + encodeURIComponent(sectionId), {
      credentials: "same-origin",
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector(".shopify-section");
        if (!fresh) return;
        wrapper.replaceWith(fresh);
      })
      .catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshContactSection);
  } else {
    refreshContactSection();
  }
})();
